var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",class:_vm.classes},[_c('div',{staticClass:"loading-box"},[_c('v-progress-circular',{attrs:{"size":50,"color":"secondary","indeterminate":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }